/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FloatingNotificationButton_local = {
    readonly appTabBarVisible: boolean | null;
    readonly enableZKey: boolean;
    readonly enableCommentSeen: boolean;
    readonly " $refType": "FloatingNotificationButton_local";
};
export type FloatingNotificationButton_local$data = FloatingNotificationButton_local;
export type FloatingNotificationButton_local$key = {
    readonly " $data"?: FloatingNotificationButton_local$data;
    readonly " $fragmentRefs": FragmentRefs<"FloatingNotificationButton_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FloatingNotificationButton_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appTabBarVisible",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableZKey",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCommentSeen",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'e9a4f013972a6826247da1d0b82e2a8b';
export default node;
